import { Directive, HostBinding } from '@angular/core';
import {
  CDK_MENU,
  CdkMenu,
  PARENT_OR_NEW_INLINE_MENU_STACK_PROVIDER,
} from '@angular/cdk/menu';

@Directive({
  selector: '[sch-menu]',
  standalone: true,
  providers: [
    {
      provide: CdkMenu,
      useExisting: SharedMenuDirective,
    },
    { provide: CDK_MENU, useExisting: SharedMenuDirective },
    PARENT_OR_NEW_INLINE_MENU_STACK_PROVIDER('vertical'),
  ],
})
export class SharedMenuDirective extends CdkMenu {
  @HostBinding('class') hostClass = 'sch-menu';
}
